export const isEmpty = (value: unknown): boolean => {
  if (typeof value === 'string') {
    return value.trim().length === 0
  }
  return !value
}

export function isExpired(time: string) {
  return new Date().getTime() > new Date(time).getTime()
}

export function isInWechat() {
  const ua = navigator.userAgent.toLowerCase()
  return !!ua.match(/micromessenger/i)
}

export const publicPage = ['landing', 'tools', 'vuldb']
export const isPublicPage = (path: string) => {
  const rootPath = path.match(/\w+/g)?.[0]
  return  rootPath ? publicPage.includes(rootPath) : false
}
